import Dispatcher from '../dispatcher';
import Constants from '../constants.js/Constant';
var EventEmitter = require('events').EventEmitter;
var RESPONSE_CHANGE_EVENT = 'globalResponse';
var assign = require('object-assign');

var response = null;

function parseResponse(resp) {
    if(resp != null) {response = resp}
}

var GetDomainDetailsStore = assign({}, EventEmitter.prototype, {
    emitChangeEvent: function (event) {
        this.emit(event);
    },
    bind: function (callback) {
        this.on(RESPONSE_CHANGE_EVENT, callback);
    },
    unbind: function (callback) {
        this.removeListener(RESPONSE_CHANGE_EVENT, callback);
    },
    getResponse: function () {
        return response;
    }
});

Dispatcher.register(function (action) {

    switch (action.actionType) {
        case Constants.GET_DOMAIN_DETAILS:
            var resp = action.data; 
            parseResponse(resp)
            GetDomainDetailsStore.emitChangeEvent(RESPONSE_CHANGE_EVENT);
            break;

        default:
    }
});

export default GetDomainDetailsStore;